export default function hasEventReadPermissions(permissions, environment) {
  return permissions && permissions.orderManagement
    ? !!permissions.orderManagement.find(
        p =>
          (p.identifier === environment || p.identifier === '*') &&
          p.permissions.includes('order:read-event')
      )
    : false;
}
